
export class AvailableTableFieldColumn {
    productField?: string;
    productUserFieldId?: number;
    productUserFieldName?: string;
    
    
    constructor(productField?: string, productUserFieldId?: number, productUserFieldName?: string) {
        this.productField = productField;
        this.productUserFieldId = productUserFieldId;
        this.productUserFieldName = productUserFieldName;
    }
    get key(): string {
        if (this.productField) {
            return `field_${this.productField}`;
        } else if (this.productUserFieldId !== undefined) {
            return `userfield_${this.productUserFieldId}`;
        } else {
            return 'unknown';
        }   
    }
    
    get name(): string {
        return this.productField ?? this.productUserFieldName ?? "";
    }
}